import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

import { createApp, h } from 'vue'
import { App, plugin } from '@inertiajs/inertia-vue3'
import SvgVue from 'svg-vue3';
import VueFinalModal from "vue-final-modal";
import { useUser } from "@/store/user";
import EmployeurLayout from "@/Layouts/EmployeurLayout";
import moment from "moment";
import { InertiaProgress } from '@inertiajs/progress'
import {officeRoute} from "@/helpers";
import {Inertia} from "@inertiajs/inertia";
import { Head, Link } from '@inertiajs/inertia-vue3'
import VueMatomo from 'vue-matomo'

const el = document.getElementById('app')
el.classList.add('App')
const json = JSON.parse(el.dataset.page);
useUser.setUserProfil(json.props.profil)

window.addEventListener('popstate', (event) => {
  if (Inertia.page.props.reload_on_back){
    event.stopImmediatePropagation()
    window.location.href = event.state.url
  }
})

moment.locale('fr')

InertiaProgress.init({
  delay: 500,

  // The color of the progress bar.
  color: '#189DA8',

  // Whether to include the default NProgress styles.
  includeCSS: true,

  // Whether the NProgress spinner will be shown.
  showSpinner: false, // en haut à droite
})


const app = createApp({
  render: () => h(App, {
    initialPage: json,
    resolveComponent: name => import(`./${name}`).then(({ default: page }) => {
      if (page.layout === undefined) {
        page.layout = EmployeurLayout
      }
      return page
    })
  })
});
app.config.globalProperties.$officeRoute = officeRoute
app.use(plugin)
.use(SvgVue)
.use(VueMatomo, {
  host: 'https://solency.matomo.cloud/',
  siteId: process.env.MIX_MATOMO_SITE_ID
})
.use(VueFinalModal(), {
  key: '$modal',
  dynamicContainerName: 'ModalsContainer'
})
.component('InertiaHead', Head)
.component('InertiaLink', Link)
.mixin({ methods: { route }})
.mount(el)


const matomoTracking = () => {
  window._hsp && window._hsp.push(['addPrivacyConsentListener', function(consent) {
    if(consent.categories.analytics && window._paq) {
      window._paq.push(['trackPageView']);
    }
  }]);
}
matomoTracking();
Inertia.on('finish', () => {
  matomoTracking()
})


